import React from 'react';
import classnames from 'classnames';
import {
  Container as MuiContainer,
  ContainerProps as MuiContainerProps,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  paper: {
    backgroundColor: theme.palette.background.paper
  },
  borders: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 2.5
  }
}));

type ContainerProps = MuiContainerProps & {
  borders?: boolean,
  paper?: boolean
};

export default function Container ({
  borders = false,
  paper = false,
  children,
  className,
  ...other
}: ContainerProps) {
  const classes = useStyles();
  return (
    <MuiContainer
      className={classnames(
        className,
        {
          [classes.borders]: borders,
          [classes.paper]: paper
        }
      )}
      {...other}
    >
      {children}
    </MuiContainer>
  );
}
